<template>
  <div>
    <component
      v-if="taskStateTerminated"
      :is="paymentCalculatorFormMetaData.componentName"
      :ref="paymentCalculatorFormMetaData.myRefName"
      :value="
        selectModel(modelValue, paymentCalculatorFormMetaData.dataSelectorKey)
      "
      @input="
        (newValue) =>
          updateModel(
            modelValue,
            newValue,
            paymentCalculatorFormMetaData.dataSelectorKey
          )
      "
      v-bind="paymentCalculatorFormMetaData.props"
    ></component>

    <!-- <TMOStimulator
      ref="tmosSimulator"
      v-if="modelValue && !taskStateTerminated"
      :value="modelValue"
      :percentage="modelValue.paymentPlan.ppCalculator?.settlementPercentage"
      :simulatorInput="modelValue"
    /> -->

    <TMOStimulator
      ref="tmosSimulator"
      v-if="modelValue && !taskStateTerminated"
      :value="modelValue"
      
    />

    <div class="d-flex justify-space-around"></div>

    <!-- <v-alert
      dense
      type="warning"
      outlined
      class="col-5 ma-auto mb-5"
      v-if="
        paymentPlan?.ppCalculator.totalMonthlyObligation >
        this.modelValue.budgetInfo.proposedDSPayment
      "
    >
      Monthly Obligation ({{
        paymentPlan?.ppCalculator.totalMonthlyObligation.toFixed(2)
      }}) greater than Affordability ({{
        this.modelValue.budgetInfo.proposedDSPayment.toFixed(2)
      }}).
    </v-alert> -->
    

    <div
      v-if="!disabled"
      class="d-flex flex-row align-start flex-wrap justify-space-around pa-2 my-5"
    >
      <div
        :class="actionMetaData.boundaryClass"
        v-for="(actionMetaData, indx) in actionMetaDataListFiltered"
        :key="indx"
      >
        <component
          :is="actionMetaData.componentName"
          v-bind="actionMetaData.props"
        ></component>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import * as Snackbar from "node-snackbar";
import * as Action from "@/../src-gen/action";
import * as Data from "@/../src-gen/data";
import FEnrollmentPPScheduleFDataTableMDP from "./FEPPScheduleFDataTableMDP";

import FEPSkipedPresentedFDataTableMDP from "./FEPSkipedPresentedFDataTableMDP";
import AddEPsEntryFFormMDP from "./AddEPsEntryFFormMDP";

import * as Store from "@/../src-gen/store";
import ApplyDiscountOnMsfFFormMDP from "./ApplyDiscountOnMsfFFormMDP";
import ModelVue from "@/components/ModelVue";
import FForm from "@/components/form/FForm.vue";
import FBtn from "@/components/FBtn.vue";
import FDataTable from "@/components/table/FDataTable.vue";
import TMOStimulator from "@/components/generic/tmoSimulatorP3/TMOStimulator.vue";

@Component({
  components: {
    FForm,
    FBtn,
    FDataTable,
    TMOStimulator,
  },
})
export default class FEPaymentPlan extends ModelVue {
  tab = 0;

  showAddPsEntryForm: boolean = false;
  showUploadForm: boolean = false;
  showModifyForm: boolean = false;
  addPsEntryInput: Data.ClientFile.AddPSEntryInput =
    new Data.ClientFile.AddPSEntryInput();
  applyDiscountInput: Data.ClientFile.ApplyDiscountOnMsfInput =
    new Data.ClientFile.ApplyDiscountOnMsfInput();
  
  showApplyDiscountOnMsfForm: boolean = false;
  

  fPaymentScheduleFDataTableRefName: string = "fEPaymentScheduleFDataTableMDP";
  taskId = this.$route.params.taskId;

  @Store.Getter.ClientFile.ClientFileSummary.clientFileBasicInfo
  clientFileBasicInfo: Data.ClientFile.ClientFileBasicInfo;

  @Store.Getter.TaskList.Summary.executiveTaskDetails
  taskDetails: Data.TaskList.ExecutiveTaskDetails;

  @Store.Getter.Login.LoginDetails.roleList
  roleList: string[];

  get clientFileId() {
    return this.$route.params.clientFileId;
  }
  get paymentPlan(): Data.ClientFile.FiPaymentPlanInfo {
    return this.modelValue.paymentPlan;
  }

  get psEntrySchelduledList() {
    return this.paymentPlan?.paymentScheduleList.filter(
      (psEntry: any) => psEntry.status === "SCHEDULED"
    );
  }

  get psEntryPresentedList() {
    return this.paymentPlan?.paymentScheduleList.filter(
      (psEntry: any) => psEntry.status !== "SCHEDULED"
    );
  }

  get subscriptionFeeScheduleList() {
    return this.paymentPlan.subscriptionFeeScheduleList;
  }

  get actionMetaDataListFiltered() {
    return this.actionMetaDataList.filter(
      (actionMetaData) =>
        actionMetaData.condition === undefined ||
        actionMetaData.condition === true
    );
  }

  openPaymentDetails(item: any) {
    if (item.paymentId) {
      this.$router.push({
        name: "Root.CFile.CFPayment.CFPaymentDetails.CFPaymentDetails",
        params: {
          clientFileNumber: this.$route.params.clientFileNumber,
          paymentId: item.paymentId,
        },
      });
    }
  }

  resetFormsTableAndData() {
    this.showAddPsEntryForm = false;
    this.showUploadForm = false;
    this.showApplyDiscountOnMsfForm = false;
    this.showModifyForm = false;

    this.addPsEntryInput = new Data.ClientFile.AddPSEntryInput();
    this.applyDiscountInput = new Data.ClientFile.ApplyDiscountOnMsfInput();
    
    (
      this.$refs[this.fPaymentScheduleFDataTableRefName] as any
    ).clearSelectedItems();
  }

  get fPaymentScheduleFDataTableMetaData() {
    return new FEnrollmentPPScheduleFDataTableMDP({
      parent: this,
      refName: this.fPaymentScheduleFDataTableRefName,
    }).getMetaData();
  }

  get fPSkipedPresentedTableMetaData() {
    return new FEPSkipedPresentedFDataTableMDP({ parent: this }).getMetaData();
  }

  get applyDiscountFFormMetaData() {
    return new ApplyDiscountOnMsfFFormMDP({ parent: this }).getMetaData();
  }

  get addPsEntryFFormMetaData() {
    return new AddEPsEntryFFormMDP({
      parent: this,
    }).getMetaData();
  }




  get taskStateTerminated() {
    return (
      this.taskDetails.taskState === "COMPLETED" ||
      this.taskDetails.taskState === "FORCE_COMPLETED" ||
      this.taskDetails.taskState === "CANCELLED" ||
      this.taskDetails.taskState === "RESET"
    );
  }

  downloadActiveExcel() {
    const { psPlanId } = this.modelValue.paymentPlan;
    const url = `/spineapi/paymentscheduleplan/download-payment-plan-excel?psPlanId=${psPlanId}`;
    const fileName = `PaymentPlan_${this.clientFileBasicInfo.clientFileNumber}.xlsx`;
    // Helper.downloadFile(url, fileName);
  }

  uploadExcel() {
    const { psPlanId } = this.modelValue.paymentPlan;
    // this.uploadPSPlanExcelInput.newPSPlanId = psPlanId;
    // Action.Payment.UploadPaymentSchedulePlanExcel.execute(
    //   this.uploadPSPlanExcelInput,
    //   (output) => {
    //     this.resetFormsTableAndData();
    //   }
    // );
    // Action.Spine.UploadPaymentPlanExcel.execute1()
  }

  handleUploadClick() {
    this.showUploadForm = true;
  }

  isAdmin() {
    return this.roleList?.includes("Admin");
  }

  @Prop()
  paymentCalculatorFormMetaData: any;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: false })
  dataSelectorKey: boolean;

  @Prop()
  actionMetaDataList: any[];
}
</script>
